import { jsx as L } from "react/jsx-runtime";
import { c as P } from "react/compiler-runtime";
import S from "highcharts";
import R from "highcharts-react-official";
import T from "highcharts/highcharts-more";
T(S);
const D = (W) => {
  const e = P(27), {
    data: t,
    title: v,
    style: y
  } = W, b = v === void 0 ? "" : v;
  let i;
  e[0] !== t.y ? (i = t.y ? [t.y] : [], e[0] = t.y, e[1] = i) : i = e[1];
  const k = '<div style="text-align:center"><span style="font-size:25px">{y}</span><br/><span style="font-size:12px;opacity:0.4">' + t.suffix + "</span></div>";
  let o;
  e[2] !== k ? (o = {
    format: k
  }, e[2] = k, e[3] = o) : o = e[3];
  let r, n;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = {
    radius: "80%",
    backgroundColor: "#3c3c3c",
    baseWidth: 20,
    topWidth: 2,
    baseLength: "0%",
    rearLength: "0%"
  }, n = {
    radius: 10,
    backgroundColor: "#3c3c3c"
  }, e[4] = r, e[5] = n) : (r = e[4], n = e[5]);
  let c;
  e[6] !== t.name || e[7] !== i || e[8] !== o ? (c = {
    name: t.name,
    data: i,
    type: "gauge",
    dataLabels: o,
    dial: r,
    pivot: n
  }, e[6] = t.name, e[7] = i, e[8] = o, e[9] = c) : c = e[9];
  const x = c;
  let m, d, f;
  e[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (d = {
    enabled: !1
  }, f = {
    enabled: !1
  }, m = {
    type: "gauge",
    backgroundColor: "transparent"
  }, e[10] = m, e[11] = d, e[12] = f) : (m = e[10], d = e[11], f = e[12]);
  let s;
  e[13] !== b ? (s = {
    text: b
  }, e[13] = b, e[14] = s) : s = e[14];
  let h;
  e[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (h = {
    startAngle: -140,
    endAngle: 140,
    background: []
  }, e[15] = h) : h = e[15];
  let p;
  e[16] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = {
    min: 0,
    max: 100,
    minorTickInterval: "auto",
    minorTickWidth: 2,
    minorTickLength: 4,
    minorTickPosition: "outside",
    tickPixelInterval: 50,
    tickWidth: 3,
    tickPosition: "outside",
    tickLength: 10,
    lineWidth: 0,
    labels: {
      step: 2,
      distance: 20
    },
    plotBands: [{
      from: 0,
      to: 50,
      thickness: 20,
      outerRadius: "95%",
      color: "#DF5353"
    }, {
      from: 50,
      to: 80,
      thickness: 20,
      outerRadius: "95%",
      color: "orange"
    }, {
      from: 80,
      to: 100,
      thickness: 20,
      outerRadius: "95%",
      color: "#55BF3B"
    }]
  }, e[16] = p) : p = e[16];
  let a;
  e[17] !== x ? (a = [x], e[17] = x, e[18] = a) : a = e[18];
  let g;
  e[19] !== s || e[20] !== a ? (g = {
    credits: d,
    exporting: f,
    chart: m,
    title: s,
    pane: h,
    yAxis: p,
    series: a
  }, e[19] = s, e[20] = a, e[21] = g) : g = e[21];
  const _ = g;
  let l;
  e[22] !== y ? (l = {
    style: {
      height: "100%",
      ...y
    }
  }, e[22] = y, e[23] = l) : l = e[23];
  let u;
  return e[24] !== _ || e[25] !== l ? (u = /* @__PURE__ */ L("div", { children: /* @__PURE__ */ L(R, { highcharts: S, options: _, containerProps: l }) }), e[24] = _, e[25] = l, e[26] = u) : u = e[26], u;
};
export {
  D as default
};
